import { FinderFilters } from 'api/FinderApi';

export const serializeFilters = (filters: any): FinderFilters | null => {
  return {
    gender: filters.gender,
    age_from: filters.age_from,
    age_to: filters.age_to,
    city: filters.city.value,
    ...(Array.isArray(filters.preference_tags) && {
      preference_tags: filters.preference_tags.map(Number),
    }),
    ...(Array.isArray(filters.marital_statuses) && {
      marital_statuses: filters.marital_statuses.map(Number),
    }),
    ...(Array.isArray(filters.ethnicities) && {
      ethnicities: filters.ethnicities.map(Number),
    }),
    ...(Array.isArray(filters.body_types) && {
      body_types: filters.body_types.map(Number),
    }),
  };
};
